export default { sha: '80d1937e9dfeae88b29ffbd887b06b58dd0dca05', buildNumber: 'undefined' }
